<template>
  <div class="stran-brez-izbirnika pregled-vsebine">
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <p class="open-sans-30pt">
            Dobrodošli v portalu Moj T-2!
          </p>
          <p style="padding-top: 25px" class="navadno-besedilo">
            Uporabniški portal Moj T-2 je namenjen vsem uporabnikom T-2 storitev.
            <br/>
            V njem lahko enostavno upravljate s svojo T-2 identiteto (T-2 ID),
            uredite svoje naročniško razmerje, naročate storitve, spremljate porabo ali upravljate z nastavitvami.
          </p>
        </div>
        <div class="grid-container" style="padding-top: 40px">
          <div>
            <div class="levi-pomik-slika">
              <img src="/static/img/Ohorizontu/varnost.png" class="velikost-slike">
            </div>
            <div>
              <div class="pomik-besedila-o-horizontu">
                <p class="primarna-barva-pisave">
                  <b class="postavitev-naslova-o-horizontu">
                    Uporabniški račun
                  </b>
                </p>
                <p class="postavitev-besedila-o-horizontu primarna-barva-pisave">
                  T-2 uporabniški račun je vaš osebni račun oz. identiteta za prijavo v T-2
                  aplikacije.
                  Na T-2 uporabniški račun lahko <b> povežete svoje T-2 naročniško razmerje in ga
                  preprosto
                  upravljate znotraj portala Moj T-2. </b>
                </p>
              </div>
            </div>
          </div>
          <div>
            <div class="levi-pomik-slika">
              <img src="/static/img/Ohorizontu/enotna-prijava.png" class="velikost-slike">
            </div>
            <div>
              <div class="pomik-besedila-o-horizontu">
                <p class="primarna-barva-pisave">
                  <b class="postavitev-naslova-o-horizontu">
                    Enotna prijava za vse T-2 aplikacije
                  </b>
                </p>
                <p class="postavitev-besedila-o-horizontu primarna-barva-pisave">
                  Z ustvarjenim T-2 računom lahko brez ponovne prijave dostopate do vseh T-2 spletnih mest.
                  Za lažjo prijavo v Moj T-2 in ostale T-2 aplikacije preprosto
                  <b>povežite svoj uporabniški račun z vašim Facebook, Google ali Apple računom.</b>
                  Elektronskega naslova vam tako ne bo več potrebno vpisovati.
                </p>
              </div>
            </div>
          </div>
          <div>
            <div class="levi-pomik-slika">
              <img src="/static/img/Ohorizontu/uporabniske-pravice.png" class="velikost-slike">
            </div>
            <div>
              <div class="pomik-besedila-o-horizontu">
                <p class="primarna-barva-pisave">
                  <b class="postavitev-naslova-o-horizontu">
                    Dodeljevanje uporabniških pravic
                  </b>
                </p>
                <p class="postavitev-besedila-o-horizontu primarna-barva-pisave">
                  Naročniki T-2 storitev lahko <b> dostop do svojega naročniškega razmerja dodelite
                  tudi
                  ostalim članom družine ali istega gospodinjstva. </b> Omogočite jim lahko pravice za
                  ogled
                  mobilne televizije tv2go, spremljanje porabe mobilnih naročnin in drugih nastavitev.
                  Pravice lahko kadarkoli onemogočite.
                </p>
              </div>
            </div>
          </div>
          <div>
            <div class="levi-pomik-slika">
              <img src="/static/img/Ohorizontu/dobrodoslica.png" class="velikost-slike">
            </div>
            <div>
              <div class="pomik-besedila-o-horizontu">
                <p class="primarna-barva-pisave">
                  <b class="postavitev-naslova-o-horizontu">
                    Najhitrejša pot do želenih storitev
                  </b>
                </p>
                <p class="postavitev-besedila-o-horizontu primarna-barva-pisave">
                  Želite naročiti dodatni
                  <b>
                    TV programski paket
                  </b>
                  ali
                  <b>
                    TV vmesnik
                  </b>?
                  <br/>
                  Želene storitve lahko enostavno vklopite takoj ali oddate naročilo preko portala MOJ T-2,
                  brez obiska poslovalnice.
                  <br>
                  <br>
                </p>
              </div>
            </div>
          </div>
        </div>
        <a :href=stranUrl class="primarna-barva" target="_blank">
          <div style="margin-top: 55px;">
            <div id="bottom">
              <div class="postavitev-besedila-pomoc">
                <p class="open-sans-13pt no-bold">
            <span class="desni-pomik-texta-pomoc">
              <b>
                Potrebujete pomoč?
              </b>
            </span>
                  <br />
                  Imamo odgovore na pogosta vprašanja,
                  <br />
                  lahko nas tudi pokličete na 064 064 064.
                </p>
              </div>
              <div class="desna-postavitev-ikone-pomoc">
                <i class="fa fa-question-circle"></i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import {povezave} from './../../../../assets/js/Povezave/povezave'

export default {
  name: 'OMojemT2',
  data () {
    return {
      clientAgent: null,
      stranUrl: ''
    }
  },
  mounted () {
    this.stranUrl = povezave.BASE_URL_MOJ_T_2
  }
}
</script>
<style scoped src="../../../../../static/css/UporabniskiKoticek/Ohorizontu.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UporabniskiKoticek/OMojemT2.vue